import React, { useEffect, useState } from 'react';
import { TrendingUpIcon, UsersIcon, AwardIcon, TargetIcon } from 'lucide-react';
export function AuthorBio() {
  const images = ['https://uploadthingy.s3.us-west-1.amazonaws.com/aZ41yWsvw3Ys3qFztBknzU/Generated_Image_October_06%2C_2025_-_3_36PM.png', 'https://uploadthingy.s3.us-west-1.amazonaws.com/wN1c99C5pV1ppV8Li7kJbG/WhatsApp_Image_2025-11-10_at_21.03.00.jpg'];
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImageIndex(prevIndex => (prevIndex + 1) % images.length);
    }, 2000);
    return () => clearInterval(interval);
  }, []);
  const stats = [{
    icon: TrendingUpIcon,
    value: '10+',
    label: 'Años de Experiencia'
  }, {
    icon: UsersIcon,
    value: '15,000+',
    label: 'Estudiantes'
  }, {
    icon: AwardIcon,
    value: '+$50M',
    label: 'Generados Online'
  }, {
    icon: TargetIcon,
    value: '500+',
    label: 'Casos de Éxito'
  }];
  const recognitions = [{
    name: 'Forbes',
    logo: '📰'
  }, {
    name: 'Entrepreneur',
    logo: '💼'
  }, {
    name: 'Inc. Magazine',
    logo: '📊'
  }, {
    name: 'Business Insider',
    logo: '📈'
  }];
  return <section data-id="element-25">
      <div className="max-w-5xl mx-auto" data-id="element-26">
        <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold mb-8 md:mb-12 text-center leading-tight" data-id="element-27">
          Conoce a Tu Mentor
        </h2>

        <div className="bg-gray-800 bg-opacity-50 rounded-2xl p-6 md:p-8 lg:p-10 shadow-2xl" data-id="element-28">
          <div className="flex flex-col md:flex-row items-center gap-6 md:gap-8 mb-8" data-id="element-29">
            <div className="w-full md:w-1/3 flex-shrink-0" data-id="element-30">
              <div className="aspect-square w-full overflow-hidden rounded-xl shadow-lg" data-id="element-31">
                <img src={images[currentImageIndex]} alt="Gabriel Beltrán" className="w-full h-full object-cover transition-opacity duration-500" data-id="element-32" />
              </div>
            </div>
            <div className="flex-1 text-center md:text-left" data-id="element-33">
              <h3 className="text-2xl md:text-3xl font-bold text-white mb-2" data-id="element-34">
                Gabriel Beltrán
              </h3>
              <p className="text-red-400 font-semibold text-lg mb-2" data-id="element-35">
                Emprendedor Digital & Mentor
              </p>
              <p className="text-gray-400 text-sm mb-4" data-id="element-36">
                Basado en Miami, FL • Speaker Internacional • Mentor de
                Emprendedores
              </p>
              <p className="text-gray-300 text-base md:text-lg leading-relaxed" data-id="element-37">
                Experto en marketing digital y creación de negocios online. Ha
                ayudado a miles de personas a generar ingresos pasivos usando
                estrategias de IA y automatización.
              </p>
            </div>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6 mb-8" data-id="element-38">
            {stats.map((stat, index) => {
            const Icon = stat.icon;
            return <div key={index} className="bg-gray-900/50 rounded-lg p-4 text-center border border-gray-700" data-id="element-39">
                  <Icon className="h-6 w-6 md:h-8 md:w-8 text-red-400 mx-auto mb-2" data-id="element-40" />
                  <div className="text-xl md:text-2xl font-bold text-white mb-1" data-id="element-41">
                    {stat.value}
                  </div>
                  <div className="text-xs md:text-sm text-gray-400" data-id="element-42">
                    {stat.label}
                  </div>
                </div>;
          })}
          </div>

          <div className="border-t border-gray-700 pt-6" data-id="element-43">
            <p className="text-center text-sm text-gray-400 mb-4" data-id="element-44">
              Reconocido por:
            </p>
            <div className="flex flex-wrap justify-center items-center gap-6 md:gap-8" data-id="element-45">
              {recognitions.map((recognition, index) => <div key={index} className="flex items-center gap-2 text-gray-400 text-sm md:text-base" data-id="element-46">
                  <span className="text-2xl" data-id="element-47">{recognition.logo}</span>
                  <span data-id="element-48">{recognition.name}</span>
                </div>)}
            </div>
          </div>
        </div>
      </div>
    </section>;
}